import s from './WebsiteCellRenderer.scss'

const WebsiteCellRenderer = ({ data }) => {
  if (!data) return null
  const { website } = data

  return (
    <a className={s.link} href={website} target="_blank" rel="noopener noreferrer">
      {website}
    </a>
  )
}

export default WebsiteCellRenderer
